module.exports = __webpack_public_path__ + "img/img13.73d89af4.svg";